export const selectUsersState = (state) => state.users;

export const selectUsers = (state) => state.users.users;
export const selectUsersCount = (state) => state.users.usersCount;

export const selectUser = (state) => state.users.user;
export const selectMe = (state) => state.users.me;

export const selectNotifications = (state) =>
  state.users.notifications;

export const selectSeeker = (state) =>
  state.users.seeker;

export const selectConfigApplicationsState = (state) =>
  state.users.config_applications_state;
